import React from 'react';

const SpecialInstructionCard = ({ specialInstruction, setSpecialInstruction }) => {
  return (
    <div style={styles.infoCard}>
      <div style={styles.cardTitle}>Referral Code (Optional)</div>
      <input
        type="text"
        placeholder="Add referral code..."
        value={specialInstruction}
        onChange={(e) => setSpecialInstruction(e.target.value)}
        style={styles.inputBox}
      />
    </div>
  );
};

const styles = {
  infoCard: {
    backgroundColor: "#fff",
    margin: "14px 10px",
    borderRadius: 20,
    padding: 16,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
  },
  cardTitle: {
    color: "#2E2E2E",
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "12px",
  },
  inputBox: {
    border: "1px solid #ccc",
    borderRadius: 8,
    padding: "10px 12px",
    fontSize: 14,
    fontWeight: "500",
    width: "100%",
    color: "#000",
    outline: "none",
    lineHeight: "10px", // your requested line height
    height: "38px",      // optimal for single-line input
    boxSizing: "border-box",
  },
};

export default SpecialInstructionCard;
